import { gql } from '@apollo/client';

export default gql`
  mutation revertChange($bookingReference: String!) {
    revertChange(bookingReference: $bookingReference) {
      reference
    }
  }
`;
